import { moneyFormat } from '~/utils/functions';

export type DiscountMode = 'percentual' | 'monetario';

export const parseDiscountNumber = (value: unknown): number => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return Number.isNaN(value) ? 0 : value;

  const valueString = String(value).trim();
  if (!valueString) return 0;

  const normalizedValue =
    valueString.length >= 8
      ? valueString.replace(/[^\d,]/g, '').replace(',', '.')
      : valueString.replace(',', '.');

  const parsedValue = parseFloat(normalizedValue);
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

const clampDiscountPercentage = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  return Math.min(Math.max(value, 0), 100);
};

export const calcDiscountPercentage = (
  discountValue: unknown,
  discountMode: DiscountMode,
  baseValue: number,
): number => {
  const parsedDiscount = parseDiscountNumber(discountValue);

  if (discountMode === 'percentual') {
    return clampDiscountPercentage(parsedDiscount);
  }

  if (baseValue <= 0) return 0;

  const discountAmount = Math.min(parsedDiscount, baseValue);
  const percentage = (discountAmount / baseValue) * 100;

  return clampDiscountPercentage(Number(percentage.toFixed(6)));
};

export const calcDiscountAmount = (
  discountPercentage: number,
  baseValue: number,
): number => {
  if (baseValue <= 0) return 0;

  const amount = (discountPercentage / 100) * baseValue;
  return Math.min(Math.max(amount, 0), baseValue);
};

export const formatDiscountForGrid = (
  discountMode: DiscountMode,
  discountPercentage: number,
  baseValue: number,
): string => {
  if (discountMode === 'monetario') {
    const discountAmount = calcDiscountAmount(discountPercentage, baseValue);
    return `R$ ${moneyFormat(discountAmount.toFixed(2))}`;
  }

  return `${moneyFormat(String(discountPercentage))}%`;
};
